<template>
  <div class="container">
    <div class="title">
      <span>关联项目信息</span>
    </div>
    <div class="center">
        <a-table :data-source="projectData" bordered :pagination="false">
            <a-table-column  key="project_name" title="* 项目名称" data-index="project_name" style="color:red;" />
            <a-table-column key="project_code" title="* 项目编号" data-index="project_code" />
            <a-table-column key="projece_pay" title="项目金额（元）"  data-index="projece_pay" />
            <a-table-column key="amount_paid" title="* 已付金额" data-index="amount_paid" />
        </a-table>
    </div>
  </div>
</template>

<script>
export default {
    props: [
        'projectData'
    ],
    data() {
        return {
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    .title {
    font-weight: 700;
    margin-left: 0px;
    margin-bottom: 10px;
    color: black;

    }
    
}
.center {
        padding: 10px 15px;
        /deep/ .line{
            color: #f5222d !important;
        }
    }
 



</style>